import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { type CreateShipmentFailure } from "./return";

export enum EasyPostErrorCodes {
  AUSPOST_ADDRESS_VALIDATION_ERROR = "AUSPOST_ADDRESS_VALIDATION_ERROR",
}

export enum RedoShipmentErrorCodes {
  LABEL_PRICE_TOO_HIGH = "LABEL_PRICE_TOO_HIGH",
}

export enum UnknownShipmentErrorCodes {
  UNKNOWN_EASYPOST_ERROR = "UNKNOWN_EASYPOST_ERROR",
  UNKNOWN_SHIPMENT_ERROR = "UNKNOWN_SHIPMENT_ERROR",
}

export type ShipmentErrorCodes =
  | EasyPostErrorCodes
  | RedoShipmentErrorCodes
  | UnknownShipmentErrorCodes;

export type KnownShipmentErrorCode = Exclude<
  ShipmentErrorCodes,
  UnknownShipmentErrorCodes
>;

export type KnownShipmentFailure = CreateShipmentFailure & {
  errorCode: KnownShipmentErrorCode;
};

export const RedoShipmentErrorMessages: Record<RedoShipmentErrorCodes, string> =
  {
    [RedoShipmentErrorCodes.LABEL_PRICE_TOO_HIGH]: "Label price too high",
  } as const;

export const EasyPostErrorMessages = {
  AUSPOST_ADDRESS_SUBURB_STATE_POSTCODE_MISMATCH:
    "Your combination of suburb, state & postcode doesn't match",
} as const;

export const EASYPOST_ERROR_PATTERN_MAPPINGS = [
  {
    errorCode: EasyPostErrorCodes.AUSPOST_ADDRESS_VALIDATION_ERROR,
    patterns: [
      EasyPostErrorMessages.AUSPOST_ADDRESS_SUBURB_STATE_POSTCODE_MISMATCH,
    ],
  },
] as const;

export const ShipmentErrorCodeValues = [
  ...Object.values(EasyPostErrorCodes),
  ...Object.values(RedoShipmentErrorCodes),
  ...Object.values(UnknownShipmentErrorCodes),
];

export const EasyPostErrorCodesZodSchema = createEnum(EasyPostErrorCodes, {
  enumName: "EasyPostErrorCodes",
});

export const RedoShipmentErrorCodesZodSchema = createEnum(
  RedoShipmentErrorCodes,
  {
    enumName: "RedoShipmentErrorCodes",
  },
);

export const UnknownShipmentErrorCodesZodSchema = createEnum(
  UnknownShipmentErrorCodes,
  {
    enumName: "UnknownShipmentErrorCodes",
  },
);

export const ReturnShipmentErrorCodesZodSchema = z.union([
  EasyPostErrorCodesZodSchema,
  RedoShipmentErrorCodesZodSchema,
  UnknownShipmentErrorCodesZodSchema,
]);
